export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      contact: 'Contact Us',
      leaders: 'The Leaders of Elixir.AI'
    },
    hero: {
      slogan: 'Data Made Intelligent',
      title: 'Transform Your Business with ',
      titleAccent: 'AI-Driven Intelligence',
      subtitle: 'Empowering organizations with cutting-edge data solutions, generative AI, and geospatial analytics',
      cta: 'Get Started'
    },
    about: {
      title: 'Our Solutions',
      subtitle: 'Innovative technology solutions tailored for your business needs',
      solutions: [
        {
          title: 'Data Driven Business Solutions',
          description: 'Leverage advanced analytics and business intelligence to make informed decisions. Our data-driven approach transforms raw data into actionable insights, enabling strategic growth and operational excellence.'
        },
        {
          title: 'Gen AI',
          description: 'Harness the power of Generative AI to automate processes, enhance creativity, and drive innovation. From natural language processing to intelligent automation, we build AI solutions that revolutionize your operations.'
        },
        {
          title: 'Analytics',
          description: 'Comprehensive analytics solutions that provide deep insights into your business performance. Real-time dashboards, predictive modeling, and custom reporting to keep you ahead of the curve.'
        },
        {
          title: 'GeoMapping',
          description: 'Advanced geospatial analytics and mapping solutions for location-based insights. Optimize logistics, understand regional trends, and make location-intelligent decisions with our cutting-edge GIS technology.'
        },
        {
          title: 'Custom Dashboards',
          description: 'Tailored visualization platforms that transform complex data into intuitive, interactive dashboards. Real-time monitoring, custom KPIs, and role-based views that empower decision-makers at every level of your organization.'
        },
        {
          title: 'Data Standardization',
          description: 'Ensure data quality and consistency across your organization with our comprehensive standardization frameworks. From data cleansing to format unification, we establish robust data governance that enhances reliability and interoperability.'
        }
      ]
    },
    leaders: {
      title: 'Leadership Team',
      subtitle: 'Meet the visionaries driving innovation at Elixir.AI',
      ceo: {
        name: 'Mayurakshi Das',
        title: 'Founder & Chief Executive Officer',
        bio: 'Entrepreneur, technology leader, and innovator with decades of global experience in building organizations, leading high-performing teams, and delivering AI-driven solutions. As Founder and CEO, Mayurakshi drives the company\'s vision, strategy, and growth while fostering innovation and creating impactful technology solutions for public and private sector organizations.'
      },
      cto: {
        name: 'Vijay Solanky',
        title: 'Chief Technology Officer',
        bio: 'Geoinformatics specialist and technology leader with expertise in remote sensing, geospatial analytics, AI/ML, and sustainable land management. Vijay drives the development of innovative data-driven solutions that support climate resilience, environmental conservation, and sustainable agriculture.'
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      getInTouch: 'Get in Touch',
      offices: 'Our Offices',
      phones: ['+49 176 24240990', '+49 171 5410657'],
      emails: [
        {
          name: 'Mayurakshi Das',
          email: 'mayurakshi@elixirai.co.in'
        },
        {
          name: 'Michael Kroll',
          email: 'm.kroll@das-berater.team'
        },
        {
          name: 'Andreas Lauenroth',
          email: 'lukaandreas19@gmail.com'
        }
      ],
      india: {
        title: 'India Office',
        address: 'Global Square Commercial Building, Opp. Deccan College, Yerwada, Pune - 411006, Maharashtra'
      },
      germany: {
        title: 'Germany Office',
        address: 'Hauptstraße 52, D-23879 Mölln'
      }
    },
    footer: {
      copyright: '© 2026 Elixir.AI. All rights reserved.',
      tagline: 'Data Made Intelligent',
      contact: 'Get in Touch'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      contact: 'Kontakt',
      leaders: 'Die Führungskräfte von Elixir.AI'
    },
    hero: {
      slogan: 'Daten intelligent gemacht',
      title: 'Transformieren Sie Ihr Geschäft mit ',
      titleAccent: 'KI-gesteuerter Intelligenz',
      subtitle: 'Wir befähigen Organisationen mit modernsten Datenlösungen, generativer KI und räumlicher Analytik',
      cta: 'Jetzt starten'
    },
    about: {
      title: 'Unsere Lösungen',
      subtitle: 'Innovative Technologielösungen, die auf Ihre Geschäftsanforderungen zugeschnitten sind',
      solutions: [
        {
          title: 'Datengesteuerte Geschäftslösungen',
          description: 'Nutzen Sie fortschrittliche Analytik und Business Intelligence, um fundierte Entscheidungen zu treffen. Unser datengesteuerter Ansatz verwandelt Rohdaten in umsetzbare Erkenntnisse und ermöglicht strategisches Wachstum und operative Exzellenz.'
        },
        {
          title: 'Generative KI',
          description: 'Nutzen Sie die Kraft der generativen KI, um Prozesse zu automatisieren, Kreativität zu fördern und Innovationen voranzutreiben. Von der Verarbeitung natürlicher Sprache bis zur intelligenten Automatisierung bauen wir KI-Lösungen, die Ihre Abläufe revolutionieren.'
        },
        {
          title: 'Analytik',
          description: 'Umfassende Analyselösungen, die tiefe Einblicke in Ihre Geschäftsleistung bieten. Echtzeit-Dashboards, Vorhersagemodellierung und benutzerdefinierte Berichte, um Sie der Zeit voraus zu halten.'
        },
        {
          title: 'Geokartierung',
          description: 'Fortschrittliche räumliche Analytik und Kartierungslösungen für standortbasierte Erkenntnisse. Optimieren Sie die Logistik, verstehen Sie regionale Trends und treffen Sie standortintelligente Entscheidungen mit unserer modernsten GIS-Technologie.'
        },
        {
          title: 'Benutzerdefinierte Dashboards',
          description: 'Maßgeschneiderte Visualisierungsplattformen, die komplexe Daten in intuitive, interaktive Dashboards verwandeln. Echtzeitüberwachung, benutzerdefinierte KPIs und rollenbasierte Ansichten, die Entscheidungsträger auf allen Ebenen Ihrer Organisation befähigen.'
        },
        {
          title: 'Datenstandardisierung',
          description: 'Gewährleisten Sie Datenqualität und Konsistenz in Ihrer gesamten Organisation mit unseren umfassenden Standardisierungs-Frameworks. Von der Datenbereinigung bis zur Formatvereinheitlichung etablieren wir robuste Data Governance, die Zuverlässigkeit und Interoperabilität verbessert.'
        }
      ]
    },
    leaders: {
      title: 'Führungsteam',
      subtitle: 'Lernen Sie die Visionäre kennen, die Innovationen bei Elixir.AI vorantreiben',
      ceo: {
        name: 'Mayurakshi Das',
        title: 'Gründerin und Chief Executive Officer',
        bio: 'Unternehmerin, Technologieführerin und Innovatorin mit jahrzehntelanger globaler Erfahrung im Aufbau von Organisationen, in der Führung leistungsstarker Teams und bei der Bereitstellung KI-gestützter Lösungen. Als Gründerin und CEO treibt Mayurakshi die Vision, Strategie und das Wachstum des Unternehmens voran und fördert gleichzeitig Innovationen und schafft wirkungsvolle Technologielösungen für Organisationen des öffentlichen und privaten Sektors.'
      },
      cto: {
        name: 'Vijay Solanky',
        title: 'Chief Technology Officer',
        bio: 'Geoinformatik-Spezialist und Technologieführer mit Expertise in Fernerkundung, räumlicher Analytik, KI/ML und nachhaltiger Landverwaltung. Vijay treibt die Entwicklung innovativer datengesteuerter Lösungen voran, die Klimaresilienz, Umweltschutz und nachhaltige Landwirtschaft unterstützen.'
      }
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Nehmen Sie Kontakt mit unserem Team auf',
      getInTouch: 'Kontakt aufnehmen',
      offices: 'Unsere Büros',
      phones: ['+49 176 24240990', '+49 171 5410657'],
      emails: [
        {
          name: 'Mayurakshi Das',
          email: 'mayurakshi@elixirai.co.in'
        },
        {
          name: 'Michael Kroll',
          email: 'm.kroll@das-berater.team'
        },
        {
          name: 'Andreas Lauenroth',
          email: 'lukaandreas19@gmail.com'
        }
      ],
      india: {
        title: 'Büro Indien',
        address: 'Global Square Commercial Building, Opp. Deccan College, Yerwada, Pune - 411006, Maharashtra'
      },
      germany: {
        title: 'Büro Deutschland',
        address: 'Hauptstraße 52, D-23879 Mölln'
      }
    },
    footer: {
      copyright: '© 2026 Elixir.AI. Alle Rechte vorbehalten.',
      tagline: 'Daten intelligent gemacht',
      contact: 'Kontakt aufnehmen'
    }
  },
  nl: {
    nav: {
      home: 'Home',
      about: 'Over ons',
      contact: 'Contact',
      leaders: 'De leiders van Elixir.AI'
    },
    hero: {
      slogan: 'Data intelligent gemaakt',
      title: 'Transformeer uw bedrijf met ',
      titleAccent: 'AI-gedreven intelligentie',
      subtitle: 'Organisaties versterken met geavanceerde dataoplossingen, generatieve AI en geospatiale analyses',
      cta: 'Aan de slag'
    },
    about: {
      title: 'Onze oplossingen',
      subtitle: 'Innovatieve technologieoplossingen op maat van uw zakelijke behoeften',
      solutions: [
        {
          title: 'Datagedreven bedrijfsoplossingen',
          description: 'Maak gebruik van geavanceerde analyses en business intelligence om weloverwogen beslissingen te nemen. Onze datagedreven aanpak transformeert ruwe data in bruikbare inzichten en maakt strategische groei en operationele excellentie mogelijk.'
        },
        {
          title: 'Generatieve AI',
          description: 'Benut de kracht van generatieve AI om processen te automatiseren, creativiteit te bevorderen en innovatie te stimuleren. Van natuurlijke taalverwerking tot intelligente automatisering, wij bouwen AI-oplossingen die uw activiteiten revolutioneren.'
        },
        {
          title: 'Analytics',
          description: 'Uitgebreide analyseoplossingen die diepgaande inzichten bieden in uw bedrijfsprestaties. Realtime dashboards, voorspellende modellering en aangepaste rapportage om u voor te blijven.'
        },
        {
          title: 'GeoMapping',
          description: 'Geavanceerde geospatiale analyses en kaartoplossingen voor locatiegebaseerde inzichten. Optimaliseer logistiek, begrijp regionale trends en neem locatie-intelligente beslissingen met onze geavanceerde GIS-technologie.'
        },
        {
          title: 'Aangepaste Dashboards',
          description: 'Op maat gemaakte visualisatieplatforms die complexe gegevens omzetten in intuïtieve, interactieve dashboards. Real-time monitoring, aangepaste KPI\'s en op rollen gebaseerde weergaven die besluitvormers op elk niveau van uw organisatie ondersteunen.'
        },
        {
          title: 'Datastandaardisatie',
          description: 'Zorg voor datakwaliteit en consistentie in uw hele organisatie met onze uitgebreide standaardisatiekaders. Van gegevensopschoning tot formaatunificatie, wij stellen robuuste data governance vast die betrouwbaarheid en interoperabiliteit verbetert.'
        }
      ]
    },
    leaders: {
      title: 'Leiderschapsteam',
      subtitle: 'Ontmoet de visionairs die innovatie stimuleren bij Elixir.AI',
      ceo: {
        name: 'Mayurakshi Das',
        title: 'Oprichter en Chief Executive Officer',
        bio: 'Ondernemer, technologieleider en innovator met tientallen jaren wereldwijde ervaring in het opbouwen van organisaties, het leiden van hoogpresterende teams en het leveren van AI-gedreven oplossingen. Als oprichter en CEO stuurt Mayurakshi de visie, strategie en groei van het bedrijf aan, terwijl ze innovatie bevordert en impactvolle technologieoplossingen creëert voor organisaties in de publieke en private sector.'
      },
      cto: {
        name: 'Vijay Solanky',
        title: 'Chief Technology Officer',
        bio: 'Geoinformatica specialist en technologieleider met expertise in remote sensing, geospatiale analyses, AI/ML en duurzaam landbeheer. Vijay stimuleert de ontwikkeling van innovatieve datagedreven oplossingen die klimaatbestendigheid, milieubehoud en duurzame landbouw ondersteunen.'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: 'Neem contact op met ons team',
      offices: 'Onze kantoren',
      india: {
        title: 'Kantoor India',
        address: 'Global Square Commercial Building, Opp. Deccan College, Yerwada, Pune - 411006, Maharashtra'
      },
      germany: {
        title: 'Kantoor Duitsland',
        address: 'Hauptstrasse 53, Moelln, Duitsland'
      }
    },
    footer: {
      copyright: '© 2026 Elixir.AI. Alle rechten voorbehouden.',
      tagline: 'Data intelligent gemaakt',
      contact: 'Neem contact op'
    }
  }
};